import { useMutation } from "@tanstack/react-query"
import { updateClientContactInfo } from "@/api"

export const useUpdateClientContactInfo = () => {
  return useMutation({
    mutationFn: (payload: {
      email?: string
      phone?: string
      address?: string
      city?: string
      state?: string
      zip?: string
      changes: { field: string; from: string; to: string }[]
    }) => updateClientContactInfo(payload),
  })
}
